import React, { useState, useRef } from 'react';
import { UploadCloud, X, FileText, CheckCircle } from 'lucide-react';
interface FileUploadProps {
  label: string;
  accept?: string;
  onChange: (file: File | null) => void;
  error?: string;
  value?: File | null;
}
export function FileUpload({
  label,
  accept = '.pdf,.jpg,.jpeg,.png',
  onChange,
  error,
  value
}: FileUploadProps) {
  const inputRef = useRef<HTMLInputElement>(null);
  const [isDragging, setIsDragging] = useState(false);
  const handleDragOver = (e: React.DragEvent) => {
    e.preventDefault();
    setIsDragging(true);
  };
  const handleDragLeave = (e: React.DragEvent) => {
    e.preventDefault();
    setIsDragging(false);
  };
  const handleDrop = (e: React.DragEvent) => {
    e.preventDefault();
    setIsDragging(false);
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      onChange(e.dataTransfer.files[0]);
    }
  };
  const handleClick = () => {
    inputRef.current?.click();
  };
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      onChange(e.target.files[0]);
    }
  };
  const handleRemove = (e: React.MouseEvent) => {
    e.stopPropagation();
    onChange(null);
    if (inputRef.current) {
      inputRef.current.value = '';
    }
  };
  return <div className="w-full" data-id="element-506">
      <label className="block text-sm font-medium text-gray-700 mb-1.5" data-id="element-507">
        {label}
      </label>

      {!value ? <div onClick={handleClick} onDragOver={handleDragOver} onDragLeave={handleDragLeave} onDrop={handleDrop} className={`
            relative border-2 border-dashed rounded-lg p-6 text-center cursor-pointer transition-colors
            ${isDragging ? 'border-[#FFD700] bg-yellow-50' : 'border-gray-300 hover:border-[#FFD700] hover:bg-gray-50'}
            ${error ? 'border-red-300 bg-red-50' : ''}
          `} data-id="element-508">
          <input ref={inputRef} type="file" className="hidden" accept={accept} onChange={handleFileChange} data-id="element-509" />
          <div className="flex flex-col items-center justify-center space-y-2" data-id="element-510">
            <div className="p-2 bg-gray-100 rounded-full" data-id="element-511">
              <UploadCloud className="h-6 w-6 text-gray-500" data-id="element-512" />
            </div>
            <div className="text-sm text-gray-600" data-id="element-513">
              <span className="font-medium text-[#FFD700]" data-id="element-514">
                Click to upload
              </span>{' '}
              or drag and drop
            </div>
            <p className="text-xs text-gray-500" data-id="element-515">PDF, JPG or PNG (max. 5MB)</p>
          </div>
        </div> : <div className="relative flex items-center p-4 border border-gray-200 rounded-lg bg-gray-50" data-id="element-516">
          <div className="flex-shrink-0 h-10 w-10 bg-yellow-100 rounded-lg flex items-center justify-center text-[#FFD700]" data-id="element-517">
            <FileText className="h-5 w-5" data-id="element-518" />
          </div>
          <div className="ml-4 flex-1 min-w-0" data-id="element-519">
            <p className="text-sm font-medium text-gray-900 truncate" data-id="element-520">
              {value.name}
            </p>
            <p className="text-xs text-gray-500" data-id="element-521">
              {(value.size / 1024 / 1024).toFixed(2)} MB
            </p>
          </div>
          <div className="ml-4 flex-shrink-0 flex items-center space-x-2" data-id="element-522">
            <CheckCircle className="h-5 w-5 text-[#FFD700]" data-id="element-523" />
            <button type="button" onClick={handleRemove} className="text-gray-400 hover:text-red-500 transition-colors" data-id="element-524">
              <X className="h-5 w-5" data-id="element-525" />
            </button>
          </div>
        </div>}

      {error && <p className="mt-1 text-sm text-red-600" role="alert" data-id="element-526">
          {error}
        </p>}
    </div>;
}